"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _componentsWeb = require("@telus-uds/components-web");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StepTrackerDisplay = _interopRequireDefault(require("./StepTrackerDisplay"));
var _StepTrackerControls = _interopRequireDefault(require("./StepTrackerControls"));
var _StepTrackerSteps = _interopRequireDefault(require("./StepTrackerSteps"));
var _StepTrackerProvider = _interopRequireDefault(require("../contexts/StepTrackerProvider"));
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var StepTracker = props => {
  var {
    steps = [],
    fieldValues = {},
    preFillValues = {},
    language = _constants.CONTENTFUL_LOCALE.en,
    clickedSubmit = false,
    fieldReferences = {},
    fieldData = {},
    formMetaData = {},
    isProduction = false,
    environment = 'sandbox',
    submitForm = () => {},
    continueButtonLabel = _constants.BUTTON_TEXT[language].continue,
    submitButtonLabel = _constants.BUTTON_TEXT[language].submit
  } = props;
  if (!steps || steps.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_StepTrackerProvider.default, {
    steps: steps,
    fieldReferences: fieldReferences,
    fieldData: fieldData,
    formMetaData: formMetaData
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, {
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.Spacer, {
    space: 5
  }), /*#__PURE__*/_react.default.createElement(_StepTrackerDisplay.default, {
    language: language,
    steps: steps
  }), /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, {
    outsideGutter: false
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, null, /*#__PURE__*/_react.default.createElement(_StepTrackerSteps.default, {
    steps: steps,
    fieldValues: fieldValues,
    preFillValues: preFillValues,
    language: language,
    clickedSubmit: clickedSubmit,
    fieldReferences: fieldReferences,
    fieldData: fieldData,
    isProduction: isProduction,
    environment: environment
  })), /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, {
    horizontalAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(_StepTrackerControls.default, {
    language: language,
    submitForm: submitForm,
    fieldData: fieldData,
    continueButtonLabel: continueButtonLabel,
    submitButtonLabel: submitButtonLabel
  }))))));
};
StepTracker.propTypes = {
  steps: _propTypes.default.array,
  fieldValues: _propTypes.default.object,
  preFillValues: _propTypes.default.object,
  language: _propTypes.default.string,
  clickedSubmit: _propTypes.default.bool,
  fieldReferences: _propTypes.default.object,
  fieldData: _propTypes.default.object,
  formMetaData: _propTypes.default.object,
  isProduction: _propTypes.default.bool,
  environment: _propTypes.default.string,
  submitForm: _propTypes.default.func,
  continueButtonLabel: _propTypes.default.string,
  submitButtonLabel: _propTypes.default.string
};
var _default = exports.default = StepTracker;